import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "no-bullets"
}
const _hoisted_2 = { class: "time" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "text"
}

import { useStore } from 'vuex';
  import { computed, ref, onUpdated, onMounted,onUnmounted } from 'vue';
  import { ExternalFun } from '../../ExternalFun';
  import { NavigationFailureType } from 'vue-router';
  import { TelegramClient } from "@/websocket/Client";
  // /:src="item.self ? user.img : session.user.img"
  // 定义接口 (类型)
  interface MessageItem {
    date: string | Date;
    self: boolean;
    content: string;
  }
  
  interface Session {
    id: number;
    user: {
      name: string;
      imgId: number;
    };
    messages: MessageItem[];
  }
  
  interface User {
    name: string;
    imgId: number;
  }
  
  // 获取 store
  
export default /*@__PURE__*/_defineComponent({
  __name: 'message',
  setup(__props) {

  const imageUrl = ref(null);
  const store = useStore();
  
  // 使用 ref 创建 messageContainer
  const messageContainer = ref<HTMLElement | null>(null);
  
  // 用户信息 (计算属性)
  const user = computed<User>(() => store.state.user);
 

  // 当前会话 (计算属性)
  const session = computed<Session | undefined>(() => {
    var ses = store.state.sessions.find((session: Session) => session.id === store.state.currentSessionId);
    return ses;
  });


  const  getImageUrl =  (item:any, user:any, session:any)=>
  {
    var headId = item.self ? user.imgId : session.user.imgId
    var imgUrl = ExternalFun.getImageUrl(headId);
    return imgUrl;
  }

  const isImageUrl = (url)=> {
      if (!url) return false;
      url = url.toLowerCase();
      return (url.endsWith('.png') || url.endsWith('.jpg') || url.endsWith('.jpeg') || url.endsWith('.gif') || url.endsWith('.svg') || url.startsWith('data:image'));
    }

  
  // 时间格式化函数 (替代 filters)
  const formatTime = (date: string | Date): string => {
    const d = typeof date === 'string' ? new Date(date) : date;
    return d.getHours() + ':' + d.getMinutes();
  };
  
  // 滚动到底部的函数 (替代指令)
  const scrollToBottom = () => {
    if (messageContainer.value) {
      const el = messageContainer.value;
      el.scrollTop = el.scrollHeight - el.clientHeight;
    }
  };
  
  // 在每次 session.messages 更新后滚动到底部
  onUpdated(scrollToBottom);

  const handChatData = (newMessage)=>{

    console.log("handChatData="+newMessage);
    if(newMessage.detail&&newMessage.detail.detail)
    {
        var name = store.state.user.name;
        var message = newMessage.detail.detail
        var recipientPhone = message.recipientPhone;
        var data = message.messages[0];
        var senderId = data.senderId;
        var timestamp = data.timestamp * 1000;
        if(name == recipientPhone)
        {
          let session = store.state.sessions.find((item) => item.id === senderId);
          if (session) {
            session.messages.push({
              content: data.content,
              date: new Date(timestamp),
              self: false,
            });
          }
        }
    }

  }    


 
onMounted(() => {
  var tt1 = new Date();
  console.log("message onMounted="+tt1.getTime());
  const client = TelegramClient.getInstance();
  client.addChatUpdateListener(handChatData);
  setTimeout(() => {
    scrollToBottom();
        }, 1000);
});

onUnmounted(() => {

const client = TelegramClient.getInstance();
client.removeChatUpdateListener(handChatData);
 

});


  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "message",
    ref_key: "messageContainer",
    ref: messageContainer
  }, [
    (session.value)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(session.value.messages, (item) => {
            return (_openBlock(), _createElementBlock("li", {
              key: item.date
            }, [
              _createElementVNode("p", _hoisted_2, [
                _createElementVNode("span", null, _toDisplayString(formatTime(item.date)), 1)
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["main noself", { self: item.self }])
              }, [
                (isImageUrl(item.content))
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: item.content,
                      alt: "Image Message",
                      class: "message-image"
                    }, null, 8, _hoisted_3))
                  : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(item.content), 1))
              ], 2)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 512))
}
}

})